import http from './httpService';
import { config } from '../config';
import { getIdentity } from '../components/common/commonFuncs';
import { QuestionTypes } from '../constants/QuestionTypes';

////////////////////////////////////////////////////////////////
const prefix = '/api/v2/reports/';
const apiEndpoint = config.apiEndpoint;
////////////////////////////////////////////////////////////////

export function addReport(reportSelected) {
    return http.post(apiEndpoint + prefix + 'addReport', {
        Report_Name: reportSelected.reportName,
        Report_Desc: reportSelected.reportDesc,
        Project_ID: parseInt(reportSelected.projectID),
        Activity_By: getIdentity()
    });
}

export function updateReportConfig(updatedReportObj) {
    console.log('updatedReportObj', updatedReportObj)
    return http.post(apiEndpoint + prefix + 'updateReportConfig', {
        Report_ID: updatedReportObj.Report_ID,
        updateReportObj: JSON.stringify(updatedReportObj),
        Activity_By: getIdentity()
    });
}